import { Card, CardProps, styled } from '@mui/material'
import React, { FC } from 'react'

type Props = {
  children: React.ReactNode
}

/**
 * StyledCard is a styled component that extends the Card component.
 * It applies custom styles to the Card component using the styled function.
 * 
 * @component
 * @example
 * return (
 *   <StyledCard>
 *     // content goes here
 *   </StyledCard>
 * )
 * 
 * @param {object} theme - The theme object provided by the ThemeProvider.
 * 
 * @returns {JSX.Element} A styled Card component with custom styles.
 */
const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  margin: '0',
  padding: '2rem',
  boxShadow: '0px 4px 10px rgba(1, 1, 1, 0.2) !important',
  borderColor: theme.palette.grey[200]
}))

const DashboardCard: FC<Props & CardProps> = ({ children, sx = {} }) => {
  return (
  <StyledCard sx={sx}>{children}</StyledCard>
  )
}

export default DashboardCard